import angular from 'angular';

angular
  .module('cxRelations')
  .factory('relBindSvc', [
    '$state',
    '$q',
    'userData',
    'resourceFactorySvc',
    'authService',
    'recentRelationsSvc',
    '$timeout',
    'flySvc',
    'checkInvoiceTeamAccess',
    relBindSvc,
  ]);

function relBindSvc(
  $state,
  $q,
  userData,
  resourceFactorySvc,
  authService,
  recentRelationsSvc,
  $timeout,
  flySvc,
  checkInvoiceTeamAccess,
) {
  // This service keeps the relation in the format to bind to....
  var relations = {};
  var relationResource = resourceFactorySvc.get('relation');
  // Wrapped id in reference object
  var active = {
    id: null,
  };
  var loaded = false;
  var sections = {};
  var fieldTypes = {};

  var defaultOpenSections = [
    '3fd70070-f8c0-45a4-b3f2-23afff37061f', //Identification
  ];

  var goTo = function(id, options) {
    active.id = id;

    if (options.reloadState) {
      $state.go(
        'relations.detail',
        {
          relId: id,
          options: {
            reload: false,
          },
          fromRelBindSvc: true,
        },
        {
          reload: true,
        },
      );
      return true;
    } else {
      $state.go('relations.detail', {
        relId: id,
        fromRelBindSvc: true,
      });

      return true;
    }

    return false;
  };

  var updateFieldTypes = function(section) {
    if (!section) return;
    if (section.columns) {
      angular.forEach(section.columns, function(col) {
        angular.forEach(col, function(field) {
          if (!fieldTypes[field.id]) fieldTypes[field.id] = field.type;
        });
      });
    }
    if (section.lists) {
      angular.forEach(section.lists, function(field) {
        if (!fieldTypes[field.id]) fieldTypes[field.id] = field.type;
      });
    }
    if (section.sections) {
      angular.forEach(section.sections, updateFieldTypes);
    }
  };

  var getData = function(relationId, openSections, forceReload = false) {
    var rel = relations[relationId];
    if (!openSections || openSections.length === 0) openSections = defaultOpenSections;
    if (!rel.sectionStatus) rel.sectionStatus = {};

    //Reset section status (0: loading, 1: data available but loading new data, 2: done)
    openSections.forEach(s => (rel.sectionStatus[s] = rel.sectionStatus[s] === 2 ? 1 : 0));

    return relationResource.getData(
      {
        id: relationId,
        dataOnly: !!sections[rel.sectionConfigKey],
      },
      openSections,
      function(data) {
        if (data.sections) {
          sections[rel.sectionConfigKey] = data.sections;

          sections[rel.sectionConfigKey].forEach(section => {
            section.defaultOpen = defaultOpenSections.indexOf(section.id) >= 0;
            updateFieldTypes(section);
          });

          delete data.sections;
        }

        angular.forEach(data, function(value, key) {
          if (typeof fieldTypes[key] !== 'undefined') value.type = fieldTypes[key];
        });
        angular.extend(rel, data);
        openSections.forEach(s => (rel.sectionStatus[s] = 2));

        if (sections[rel.sectionConfigKey] && (!rel.sections || forceReload)) {
          rel.sections = angular.copy(sections[rel.sectionConfigKey]);
        }
      },
    ).$promise;
  };

  var loadSections = function(sectionConfigKey) {
    return relationResource.sections(
      {
        id: sectionConfigKey,
      },
      function(data) {
        sections[sectionConfigKey] = data;
        sections[sectionConfigKey].forEach(section => {
          section.defaultOpen = defaultOpenSections.indexOf(section.id) >= 0;
          updateFieldTypes(section);
        });
      },
    ).$promise;
  };
  var close = function(id) {
    if (relations.hasOwnProperty(id)) delete relations[id];
    if (active.id === id) active.id = null;
  };
  var open = function(id, options) {
    if (!id) return null;
    id = id.toLowerCase();

    // Make sure relation cache doesn't get too full
    if (relations && Object.keys(relations).length > 5) {
      clearCache();
    }

    //Extend default options with parameter options
    options = angular.extend(
      {
        reload: true,
        reloadSections: false,
        changeState: true,
        reloadState: false,
      },
      options || {},
    );

    goTo(id, options);

    var deferred = $q.defer();
    if (!relations[id] || !relations[id].sections || options.reload || options.reloadSections) {
      if (!relations[id]) relations[id] = { loading: true };
      if (!relations[id].sectionStatus) {
        relations[id].sectionStatus = {};
      }
      if (!relations[id].collapsedSections) relations[id].collapsedSections = {};
      if (!relations[id].sections) relations[id].loading = true;
      relationResource.get(
        {
          id: id,
        },
        function(relation) {
          $timeout(recentRelationsSvc.reloadRecentRelations, 100);

          if (!relations[relation.id]) relations[relation.id] = {};
          var rel = relations[relation.id];

          defaultOpenSections.forEach(s => (rel.collapsedSections[s] = false));

          //Clear sections if config key is changed
          if (relation.sectionConfigKey !== rel.sectionConfigKey) rel.sections = null;

          // Comment: this way we overwrite fields that appear more than once, but that does not matter.
          // First the values that are in the relation object directly
          angular.forEach(relation, function(value, key) {
            if (key === 'sections' && value === null) return;
            if (key === 'loadedSections') return;

            //Set field type property in relation fields
            if (typeof fieldTypes[key] !== 'undefined') value.type = fieldTypes[key];
            rel[key] = value;
          });

          rel.hasInvoiceTeamAccess = checkInvoiceTeamAccess(rel.teamSecurityCode);
          rel.loading = false;

          var sectionsToLoad = [];
          angular.forEach(rel.collapsedSections, function(value, key) {
            if (!value) sectionsToLoad.push(key);
          });

          if (relation.loadedSections)
            angular.forEach(relation.loadedSections, function(s) {
              sectionsToLoad = sectionsToLoad.filter(l => s !== l);
              rel.sectionStatus[s] = 2;
            });

          if (!sectionsToLoad.length) {
            if (!sections[rel.sectionConfigKey]) {
              loadSections(rel.sectionConfigKey).then(function() {
                if (sections[rel.sectionConfigKey] && !rel.sections) {
                  rel.sections = angular.copy(sections[rel.sectionConfigKey]);
                }
                //Set field type property in relation fields after loading sections
                angular.forEach(rel, function(value, key) {
                  if (!value) return;
                  if (typeof value.value === 'undefined') return;
                  if (typeof value.type !== 'undefined') return;
                  if (typeof fieldTypes[key] !== 'undefined') value.type = fieldTypes[key];
                });
                deferred.resolve(relations[id]);
              });
            } else {
              if (!rel.sections) {
                rel.sections = angular.copy(sections[rel.sectionConfigKey]);
              }
              deferred.resolve(relations[id]);
            }
          } else {
            getData(rel.id, sectionsToLoad).then(function() {
              deferred.resolve(relations[id]);
            });
          }
        },
        function(error) {
          //Close tab on error
          console.error(
            'Error retrieving relation "' + id + '": Closing tab\n' + JSON.stringify(error),
          );
          relations[id].loading = false;
          relations[id].error = error;
          flySvc.error(error);
          deferred.reject(error);
        },
      );
    } else {
      deferred.resolve(relations[id]);
    }

    return deferred.promise;
  };

  var clearCache = function() {
    for (var key in relations) if (relations.hasOwnProperty(key)) delete relations[key];
    active.id = null;
    loaded = false;
  };

  var updateRelation = function(relId, changes, billingErrors, relationName = null) {
    var rel = relations[relId];
    if (!rel) return;
    if (relationName) {
      //Copy companyId and language code from relation name dto to relation object
      const { companyId, languageCode } = relationName;
      if (companyId && rel.companyId !== companyId) rel.companyId = companyId;
      if (languageCode && rel.languageCode !== languageCode) rel.languageCode = languageCode;
    }

    // update the relation object with the changes (if any)
    if (changes)
      angular.forEach(changes, function(value, key) {
        if (rel[key] == null || typeof rel[key].value === 'undefined') {
          rel[key] = value;
        } else {
          if (angular.isArray(rel[key].value) && angular.isArray(value)) {
            rel[key].value.clear();
            Array.prototype.push.apply(rel[key].value, value);
          } else {
            rel[key].value = value;
          }
        }
      });
    rel.hasInvoiceTeamAccess = checkInvoiceTeamAccess(rel.teamSecurityCode);
    // update the billing errors: remove all billingErrors ...
    angular.forEach(rel, function(fieldValue, fieldId) {
      if (fieldValue && fieldValue.billingError) fieldValue.billingError = null;
    });
    // ... and add the new ones
    rel.billingErrors = billingErrors;

    if (billingErrors)
      angular.forEach(billingErrors, function(billingError) {
        if (rel[billingError.fieldId])
          rel[billingError.fieldId].billingError = billingError.exception;
      });
  };

  authService.addOnLogOut(function() {
    clearCache();
  });

  const getHelpArticleForField = fieldId => {
    switch (fieldId) {
      // example:
      // case '40ae0a55-fd7d-4577-830f-22589642e875':
      //   return '6784503678492';
      case '42266463-8da3-46a2-822a-cd99ffd96bc8':
        return '15870358904988';
      default:
        return undefined;
    }
  };

  return {
    active: active,
    relations: relations,
    open: open,
    close: close,

    updateRelation: updateRelation,

    loadSection: function(relationId, sectionId) {
      return getData(relationId, [sectionId]);
    },
    loadSections: function(relationId, sections) {
      return getData(relationId, sections);
    },
    refreshSection: function(relationId, sectionId) {
      return getData(relationId, [sectionId], true);
    },
    refreshSections: function(relationId, sections) {
      return getData(relationId, sections, true);
    },
    sections: sections,
    getHelpArticleForField: getHelpArticleForField,
  };
}
